function IAHintProvider() {}
IAHintProvider.categories = {
  'GwOngoingModal': [
    { id: 1, text: 'GW_MINOR_PBS' },
    { id: 2, text: 'GW_BUILD_TRUST' },
    { id: 3, text: 'GW_CHECK_OUT_SPOT_PB', senseiOption: 'SPOT_PB' },
    { id: 4, text: 'GW_SPOT_PB', senseiOption: 'SPOT_PB' },
    { id: 5, text: 'GW_NOK_MEANS_PROBLEMS' },
    { id: 6, text: 'GW_PPL_OPINION' },
    { id: 7, text: 'SPOT_UNNECESSARY_5S' },
    { id: 8, text: 'GW_NO_BLAME', senseiOption: 'NO_BLAME' },
    { id: 9, text: 'GW_TALK_TEAM' },
    { id: 10, text: 'GW_INVOLVE_TEAM' },
    { id: 11, text: 'GW_EVERYONE_OPINION' }
  ],
  'gw-ongoing-noks': [
    { id: 1, text: 'GW_TALK_TEAM' },
    { id: 2, text: 'GW_UNDERSTAND_NOK' },
    { id: 3, text: 'GW_PPL_OPINION' },
    { id: 4, text: 'GW_NOTE_IMPROV' }
  ],
  'gw-ongoing-noks-no-problems': [
    { id: 1, text: 'GW_NOK_NO_PROBLEMS' },
    { id: 2, text: 'GW_NOK_MEANS_PROBLEMS' },
    { id: 3, text: 'GW_ADD_NOK_PROBLEMS' },
    { id: 4, text: 'GW_ADD_NOK_PROBLEMS2' },
    { id: 5, text: 'PB_KEEP_TRACK' }
  ],
  'regular-meeting-reminder': [
    { id: 1, text: 'MEETING_REGULAR_BASIS', links: [] },
    { id: 2, text: 'MEETING_DAILY', links: [] },
    { id: 3, text: 'MEETING_ONE_PER_WEEK', links: [] },
    { id: 4, text: 'MEETING_RELY_TRUST', links: [] }
  ],
  'regular-gw-reminder': [
    { id: 1, text: 'GW_REGULAR_SUPPORT', links: [{ text: 'message.GW_TEMPLATES', page: '/gw-templates' }] },
    { id: 2, text: 'GW_BEEN_A_WHILE', senseiOption: 'GW' },
    { id: 3, text: 'GW_REGULAR_TRUST', senseiOption: 'GW' },
    { id: 4, text: 'GW_NEW_LOOK', senseiOption: 'GW' },
    { id: 5, text: 'GW_MAKE_GREAT', senseiOption: 'GW' }
  ],
  'regular-gw-reminder-0': [
    { id: 1, text: 'GW_NEW_LOOK', senseiOption: 'GW' },
    { id: 2, text: 'GW_MAKE_GREAT', senseiOption: 'GW' }
  ]
};

export default IAHintProvider;
